import EventBus from "@/sdk/EventBus";
/* eslint-disable-next-line @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/camelcase */
/* @ts-ignore */
import * as FX from "../lib/CoolVideo.js";
import {
  ChatType,
  Command,
  ProtoMessageEnum,
  ProtoMessageType,
} from "./Contact";
import IMError from "@/sdk/IMError";
// import { message } from "ant-design-vue";
// import { getToken, getSignature, appSecret } from "@/sdk/getToken";
interface CoreProps extends NWOption {
  /**
   * 默认前缀
   */
  cont: string;
  /**
   * 用户唯一标识符 userId/resource
   */
  userIdStr: string;
}

export interface SendFileOrImgPayload {
  to: string;
}
// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface NWOption {
  hooks?: {
    // 文件/图片上传之前触发的钩子
    beforeSendFile?: null;
  };
  maxLength?: number;
  /**
   * 服务器url
   */
  url: string;
  /**
   * 用户唯一标志符
   */
  userId: string;
  /**
   * 资源地址， 默认为web
   */
  resource?: string;
  /**
   * 认证token， 一般指的是密码
   */
  token: string; //
  /**
   * 心跳间隔
   */
  pingTime?: number;
  /**
   * 服务器
   */
  server: string;
  /**
   * 设备唯一ID
   */
  deviceId: string;
  debug?: boolean;
  /**
   * 上传服务器地址
   */
  uploadServer: string;
  /**
   * 下载服务器地址
   */
  downloadServer: string;
  /**
   * 音视频服务器地址
   */
  videoServer: string;
  /**
   * 音视频信令服务器地址
   */
  videoWS: string;
  /**
   * 是否自动重连
   * @default false
   */
  autoConnect?: boolean;
  /**
   * 自动重连间隔
   * @default 5秒
   */
  autoConnectTime?: number;
  /**
   * 自动重连次数
   * @default 3
   */
  autoConnectNum?: number;
  // onmessage?: Function; // 发送消息的回调
  // onLoginSuccess?:Function; // 登录成功的回调
}

export interface UploadResponse {
  file: File;
  response: XMLHttpRequest;
  data: {
    path: string;
    url: string;
  };
}

export interface SendMessageProps {
  /**
   * 消息ID
   */
  messageId: string;
  /**
   * 发送方Id
   */
  fromUserId: string;
  /**
   * 发送方用户名
   */
  fromUserName: string;
  /**
   * 消息正文
   */
  content: string;
  /**
   * 消息发送时间
   */
  timeSend: number;
  /**
   * 1普通消息 消息类别 2000控制， 2001发起， 2002接收到， 2003同意， 2004拒绝， 2005挂断
   */
  type: MessageType;
  /**
   * 是否已读
   */
  isReadDel: boolean;
  /**
   * 接收方ID
   */
  toUserId: string;
  /**
   * 接收方用户名
   */
  toUserName: string;
  /**
   * 接收方Id
   */
  to: string;
  /**
   * 聊天类型 1单聊， 2群聊， 3广播
   */
  chatType: number;
  /**
   *  同messageId
   */
  id: string;
  /**
   * 发送方Id
   */
  from: string;

  [key: string]: any;
}

// 发送图片请求
export interface SendImageMessageProps extends SendMessageProps {
  /**
   * 文件名称
   */
  fileName: string;
  /**
   * 消息类别2代表图片
   */
  type: 2;
  /**
   * 文件大小
   */
  fileSize: 10618;
}

// 发送文件请求
export interface SendFileMessageProps extends SendMessageProps {
  fileName: string;
  type: 9;
  fileSize: 10618;
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface NWMessageHead {
  messageId: string;
  from: string;
  to: string;
  chatType: ChatType;
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface NWMessage {
  messageHead: NWMessageHead;
  token?: string;
  deviceId?: string;
  messageId?: string;
  to?: any;
  chatType?: any;
  status?: 2;
  timeLen?: any;
  fileTime?: any;
}

export enum MessageType {
  MESSAGE = 1,
  IMAGE = 2,
  FILE = 9,
  CONTROL = 2000,
  CALL_AUDIO = 2001,
  RECEIPT_CALL_AUDIO = 2002,
  ACCEPT_CALL_AUDIO = 2003,
  REFUSE_CALL_AUDIO = 2004,
  HANGUP_AUDIO = 2005,
  CALL_VIDEO = 2011,
  RECEIPT_CALL_VIDEO = 2012,
  ACCEPT_CALL_VIDEO = 2013,
  REFUSE_CALL_VIDEO = 2014,
  HANGUP_VIDEO = 2015,
  CALL_SHARE = 2016,
  RECEIPT_CALL_SHARE = 2017,
  ACCEPT_CALL_SHARE = 2018,
  REFUSE_CALL_SHARE = 2019,
  HANGUP_SHARE = 2020,
}

export enum ControlType {
  callAudio = MessageType.CALL_AUDIO,
  hangupAudio = MessageType.HANGUP_AUDIO,
  acceptAudio = MessageType.ACCEPT_CALL_AUDIO,
  refuseAudio = MessageType.REFUSE_CALL_AUDIO,
  receiveAudio = MessageType.RECEIPT_CALL_AUDIO,
  callVideo = MessageType.CALL_VIDEO,
  acceptVideo = MessageType.ACCEPT_CALL_VIDEO,
  receiveVideo = MessageType.RECEIPT_CALL_VIDEO,
  refuseVideo = MessageType.REFUSE_CALL_VIDEO,
  hangupVideo = MessageType.HANGUP_VIDEO,
  callShare = MessageType.CALL_SHARE,
  acceptShare = MessageType.ACCEPT_CALL_SHARE,
  receiveShare = MessageType.RECEIPT_CALL_SHARE,
  refuseShare = MessageType.REFUSE_CALL_SHARE,
  hangupShare = MessageType.HANGUP_SHARE,
  openCamera = MessageType.CONTROL,
  closeCamera = MessageType.CONTROL,
  openMic = MessageType.CONTROL,
  closeMic = MessageType.CONTROL,
}
type ControlKey = keyof ControlType;

/**
 * 当前支持订阅的消息类型
 */
enum NWEventName {
  COMMAND_CHAT = "message",
  /**
   * 获取消息成功
   */
  SUCCESS = "success",
  /**
   * 消息回执
   */
  MESSAGE_RECEIPT = "receipt",
  /**
   * 认证消息
   */
  COMMAND_AUTH_RESP = "loginSuccess",
  /**
   * 被挤下线
   */
  // eslint-disable-next-line @typescript-eslint/camelcase
  Login_Conflict = "conflict",

  /**
   * 控制指令
   */
  CONTROL = "control",
  /**
   * 文件
   */
  FILE = "file",

  /**
   * 图片
   */
  IMAGE = "image",
  /**
   * 收到语音
   */
  RECEIVE_AUDIO = "receiveAudio",

  /**
   * 收到语音呼叫之后的回执
   */
  RECEIPT_CALL_AUDIO = "receiveAudioReceipt",
  /**
   * 同意语音
   */
  ACCEPT_CALL_AUDIO = "acceptAudio",

  /**
   * 拒绝语音呼叫
   */
  REFUSE_CALL_AUDIO = "refuseAudio",

  /**
   *  挂断语音
   */
  HANGUP_AUDIO = "hangupAudio",

  /**
   * 接收到视频消息
   */
  RECEIVE_VIDEO = "receiveVideo",

  /**
   * 是消息回执
   */
  RECEIPT_CALL_VIDEO = "receiveVideoReceipt",

  /**
   * 同意视频消息
   */
  ACCEPT_CALL_VIDEO = "acceptVideo",
  /**
   *  拒绝视频
   */
  REFUSE_CALL_VIDEO = "refuseVideo",

  /**
   * 挂断分享
   */
  HANGUP_SHARE = "hangupShare",
  /**
   * 接收到视频消息
   */
   RECEIVE_SHARE = "receiveShare",

   /**
    * 是消息回执
    */
   RECEIPT_CALL_SHARE = "receiveShareReceipt",
 
   /**
    * 同意视频消息
    */
   ACCEPT_CALL_SHARE = "acceptShare",
   /**
    *  拒绝视频
    */
   REFUSE_CALL_SHARE = "refuseShare",
 
   /**
    * 挂断视频
    */
   HANGUP_VIDEO = "hangupVideo",
  /**
   * 当前组件生命周期,按照以下顺序
   */
  // 建立websocket之前
  BEFORE_CONNECT = "beforeConnect",
  /**
   * 建立连接之后
   */
  CONNECTED = "connected",
  /**
   * 发送认证消息之前
   */
  BEFORE_AUTH = "beforeAuth",
  /**
   * 已发送认证消息
   */
  AFTER_AUTH = "afterAuth",

  /**
   * 销毁连接之前
   */
  BEFORE_DESTROY = "beforeDestroy",
  /**
   * 销毁连接之后
   */
  DESTROYED = "destroyed",
}

// 根据不同的消息类型， 生成不同的报文
function generateControlMessage<T extends SendMessageProps>(
  messageType: ControlType,
  payload: any | SendMessageProps
): T {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const baseMessage = <T>{
    chatType: 10,
    content: "",
    from: payload.from,
    fromUserId: payload.from,
    fromUserName: "",
    isReadDel: false,
    timeSend: 0,
    to: payload.to,
    toUserId: payload.to,
    toUserName: "",
    type: 2000,
    ...payload,
  };
  switch (messageType) {
    case ControlType.callAudio:
      baseMessage.type = 2001;
      break;
    case ControlType.receiveAudio:
      baseMessage.type = 2002;
      break;
    case ControlType.acceptAudio:
      baseMessage.type = 2003;
      break;
    case ControlType.refuseAudio:
      baseMessage.type = 2004;
      break;
    case ControlType.hangupAudio:
      baseMessage.type = 2005;
      break;
    case ControlType.callVideo:
      baseMessage.type = 2011;
      break;
    case ControlType.receiveVideo:
      baseMessage.type = 2012;
      break;
    case ControlType.acceptVideo:
      baseMessage.type = 2013;
      break;
    case ControlType.refuseVideo:
      baseMessage.type = 2014;
      break;
    case ControlType.hangupVideo:
      baseMessage.type = 2015;
      break;
    case ControlType.callShare:
      baseMessage.type = 2016;
      break;
    case ControlType.receiveShare:
      baseMessage.type = 2017;
      break;
    case ControlType.acceptShare:
      baseMessage.type = 2018;
      break;
    case ControlType.refuseShare:
      baseMessage.type = 2019;
      break;
    case ControlType.hangupShare:
      baseMessage.type = 2020;
      break;
    case ControlType.openCamera:
      baseMessage.type = 2000;
      baseMessage.content = '{command: "openCamera"}';
      break;
    case ControlType.closeCamera:
      baseMessage.type = 2000;
      baseMessage.content = '{command: "closeCamera"}';
      break;
    case ControlType.openMic:
      baseMessage.type = 2000;
      baseMessage.content = '{command: "openMic"}';
      break;
    case ControlType.closeMic:
      baseMessage.type = 2000;
      baseMessage.content = '{command: "closeMic"}';
      break;
  }
  return baseMessage;
}

class IMCore extends EventBus {
  /**
   * 用于存放当前组件的所有状态与配置
   */
  public options: CoreProps;
  /**
   * 用于存放当前组件相关缓存信息， 不建议修改
   * @private
   */
  private cache: any = {
    /*最后一次传递消息的时间*/
    lastTransferTime: 0,
    waitSendReceiptIds: "",
    //消息回执处理任务
    sendReceiptTask: 0,
    /**
     * 缓存ping指令
     */
    pingFn: null,
    reconnectNum: 0,
    meetingId: "",
    isAdd: false,
    resolve: () => void 0,
    reject: () => void 0,
  };
  /**
   * 当前IM实例 websocket 实例
   */
  websocket: null | WebSocket = null;
  /**
   * 通话组件
   */
  coolVideo: null | any;
  /**
   * 分享组件
   */
  shareCall: null | any;
  /**
   * 通话组件的DOM节点
   */
  coolVideoDom: null | FX.CoolVideo;

  /**
   * 构造函数
   * @param props
   */
  constructor(props: NWOption) {
    super();
    this.options = {
      hooks: {},
      autoConnect: false,
      maxLength: 5000,
      autoConnectNum: 3,
      autoConnectTime: 5,
      cont: "skimweb_",
      debug: false,
      deviceId: "",
      downloadServer: "",
      pingTime: 0,
      resource: "web",
      server: "",
      token: "",
      uploadServer: "",
      url: "",
      userId: "",
      videoServer: "",
      videoWS: "", //用户标识符
      userIdStr: "",
    };
    this.setOptions(props);
    return this;
  }

  /**
   * 设置属性
   * @param props
   */
  setOptions(props: any = {}) {
    this.mergeIntoThis(props, [
      "maxLength",
      "hooks",
      "debug",
      "token",
      "deviceId",
      "url",
      "resource",
      "pingTime",
      "userId",
      "resource",
      "uploadServer",
      "videoServer",
      "videoWS",
      "downloadServer",
      "autoConnect",
      "autoConnectTime",
      "autoConnectNum",
    ]);
    if (this.options.deviceId === "") {
      this.options.deviceId = this.randomUUID();
    }
    const ishttps = "https:" === location.protocol ? true : false;
    const wprotocol = ishttps
      ? location.protocol.replace("https", "wss")
      : location.protocol.replace("http", "ws");
    const whost = `${wprotocol}//${location.hostname}`;
    const host = `${location.protocol}//${location.hostname}`;
    if (this.options.url === "") {
      this.options.url = `${whost}:5261/im`;
    }
    if (this.options.videoWS === "") {
      this.options.videoWS = `${whost}:5261/video`;
    }
    if (this.options.uploadServer === "") {
      this.options.uploadServer = `${host}`;
    }
    if (this.options.downloadServer === "") {
      this.options.downloadServer = `${host}:8089`;
    }
    this.options.userIdStr = `${this.options.userId}/${this.options.resource}`;
  }

  /**
   * 合并属性到this
   * @param options 需要覆盖自身选项的配置
   * @param keys 见 NWOption 相关属性
   */
  private mergeIntoThis(options: NWOption, keys: string[]) {
    keys.forEach((v) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (options[v] !== undefined) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.options[v] = options[v];
      }
    });
  }

  /**
   * 实现了简易的数据请求
   * @param method GET POST DELETE UPDATE PATCH PUT
   * @param url 请求的url地址
   * @param data 相关的数据， 目前只支持字符串
   */
  ajax(method = "get", url: string, data: any): any {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve({
            response: xhr,
            data: JSON.parse(xhr.response),
          });
        }
      };
      // const Nonce = `${Math.random()}`;
      // const Timestamp = `${Date.now()}`;
      // const Signature = getSignature(appSecret, Nonce, Timestamp);
      xhr.onerror = reject;
      xhr.open(method.toUpperCase(), url);
      // xhr.setRequestHeader("Nonce", Nonce);
      // xhr.setRequestHeader("Timestamp", Timestamp);
      // xhr.setRequestHeader("Signature", Signature);
      xhr.setRequestHeader("content-type", "application/json");
      xhr.send(data);
    });
  }
  /**
   * 监听SDK消息
   * @param type 事件类型
   * @param callback 回调函数
   */
  public on(type: string | number, callback: Function) {
    return super.on.call(this, type, callback);
  }

  /**
   * 控制方法
   * @param method 见 ControlType
   */
  async control(method: string, payload: any) {
    const { userId, videoServer } = this.options;
    try {
      payload.content = JSON.stringify(payload.content);
    } catch (e) {
      this.log(e);
    }
    if (method === "hangupAudio" || method === "hangupVideo") {
      this.destroyMeeting();
    }
    if (
      method === ControlType[ControlType.callVideo] ||
      method === ControlType[ControlType.callAudio] ||
      method === ControlType[ControlType.callShare]
    ) {
      // @ts-ignore
      const msg = generateControlMessage(ControlType[method], {
        from: userId,
        ...payload,
      });
      let data;
      // eslint-disable-next-line no-useless-catch
      try {
        const body = JSON.stringify({
          id: "",
          ip: videoServer,
          joinUsers: [
            {
              userId: userId,
              userName:
                userId && userId.length > 20 ? userId.substr(0, 20) : userId,
              userType: 1,
            },
          ],
          roomId: "1",
          scheduleEndTime: Math.round(Date.now() / 1000) + 400,
          scheduleStartTime: Math.round(Date.now() / 1000) + 300,
          topic: "通话",
        });
        data = await this.ajax(
          "POST",
          "/api/iflyco/v1/conference?token=" + this.options.token,
          body
        );

        // data = await FX.orderMeeting();
        // @ts-ignore
        if (data.data.code === 500) {
          throw new IMError(501);
        }
      } catch (e) {
        throw e;
      }
      this.sendMessage({
        ...msg,
        content: JSON.stringify({
          // @ts-ignore
          meetingId: data.data.data.conferenceNum,
        }),
      });
      // 多人的在这里多发一条msg即可
      // this.sendMessage({
      //   ...msg,
      //   content: JSON.stringify({
      //     // @ts-ignore
      //     meetingId: data.data.data.conferenceNum,
      //   }),
      //   to: '904c7393629346968183adcf31dda571',
      //   toUserId: '904c7393629346968183adcf31dda571'
      // });
      return true;
    } else {
      // @ts-ignore
      const msg = generateControlMessage(ControlType[method], {
        from: userId,
        ...payload,
      });
      this.sendMessage({
        ...msg,
      });
    }
  }

  /**
   * 建立websocket连接
   */
  connect() {
    const websocket = new WebSocket(this.options.url);
    this.websocket = websocket;
    websocket.onopen = this.onopen.bind(this);
    websocket.onmessage = this.onmessage.bind(this);
    websocket.onerror = this.onerror.bind(this);
    websocket.onclose = this.onclose.bind(this);
    websocket.binaryType = "arraybuffer";
    this.autoSendPing();
    this.emit("beforeConnect", this);
    return new Promise((resolve, reject) => {
      this.cache.resolve = resolve;
      this.cache.reject = reject;
    });
  }

  /**
   * 自动发送ping心跳
   * @private
   */
  private autoSendPing() {
    const pingTime = (this.options.pingTime || 30) * 1000;
    this.cache.pingFn = setInterval(() => {
      this.sendPing();
    }, pingTime);
  }

  /**
   * 发送ping心跳
   */
  sendPing() {
    if (!this.isConnect()) return;
    //console.log("发送心跳包");
    const message = this.buildPingMessage();
    const buffer = this.encodeMessage(message, Command.Ping_REQ);
    this.sendBytes(buffer);
  }

  /**
   * 生成ping心跳头部
   */
  buildPingMessage() {
    const head = this.buildMessageHead("server", ChatType.PING);
    const message = {
      messageHead: head,
    };
    return message;
  }

  /**
   * 输出日志， 当初始化参数debug的时候，会输出日志， 底层是console
   * @param args
   */
  private log(...args: any[]) {
    if (this.options.debug) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      //@ts-ignore
      console.log(...args);
    }
  }

  /**
   * 当websocket建立连接的时候触发
   * @param event websocket事件
   */
  private onopen = (event: Event) => {
    this.emit("connected", event);
    this.emit("beforeAuth", this, event);
    const message = this.buildAuthMessage();
    const buffer = this.encodeMessage(message, Command.COMMAND_AUTH_REQ);
    this.sendBytes(buffer);
    this.emit("afterAuth", this, event);
  };

  /**
   * 收到服务器消息
   * @param event websocket事件
   * @private
   */
  private onmessage(event: MessageEvent) {
    this.emit("wsMessage", event);
    const dataArr = new Uint8Array(event.data);
    let cmd = dataArr[0];
    if (cmd > 127) {
      cmd = cmd - 256;
    }
    this.cache.lastTransferTime = Date.now();
    if (0 == cmd) return;
    const bytes = dataArr.subarray(1, dataArr.length);
    let message = this.decodeMessage(bytes, cmd);
    /*var dataStr=JSON.stringify(message);*/
    message = this.convertToClientMsg(message);
    this.handlerMessageByCommand(cmd, message);
  }

  /**
   * 当连接发生错误
   * @param e websocket事件
   */
  private onerror(e: Event) {
    this.log(e);
    this.emit("error", e);
    if (
      this.options.autoConnect &&
      // @ts-ignore
      this.cache.reconnectNum < this.options.autoConnectNum
    ) {
      this.reconnect();
    }
  }

  /**
   * 重连方法
   * @private
   */
  private reconnect() {
    this.log("wait for reconnect");
    setTimeout(() => {
      this.log("reconnecting");
      this.connect();
      this.cache.reconnectNum = this.cache.reconnectNum + 1;
      //@ts-ignore
      this.options.autoConnectNum = this.options.autoConnectNum + 1;
      //@ts-ignore
    }, this.options.autoConnectTime * 1000);
  }

  /**
   * 当连接关闭
   * @param e websocket事件
   */
  private onclose(e: Event) {
    this.log(e);
    this.emit("close", e);
  }

  /**
   * 当实例被销毁
   */
  destroy() {
    /**
     * 清除ping缓存函数
     */
    clearInterval(this.cache.pingFn);
    this.emit("beforeDestroy", this);
    try {
      this.websocket?.close();
      if (this.coolVideo) {
        this.destroyMeeting();
      }
    } catch (e) {
      this.log(e);
    }
    this.emit("destroyed", this);
  }

  /**
   * 销毁预定好的飞讯会议
   */
  destroyMeeting() {
    try {
      this.coolVideo.hangup();
      this.coolVideoDom.hangup();
      this.coolVideoDom.logout();
      this.ajax(
        "put",
        `/api/iflyco/v1/conference/finish/${this.cache.meetingId}?token=${this.options.token}`,
        ""
      );
    } catch (e) {
      this.log(e);
    }
  }

  /**
   * 填充消息体，减少重复的必填参数
   * @param msg 见SendMessageProps
   */
  private fillMsg(msg: SendMessageProps): SendMessageProps {
    return {
      ...msg,
      isReadDel: false,
      toUserId: msg.to,
      chatType: 1,
      fromUserId: this.options.userId,
      from: this.options.userIdStr,
      timeSend: Date.now(),
    };
  }

  /**
   * 发送消息 api， 不建议使用内部API
   * @param msg 见SendMessageProps
   * @param cmd 可选，见Command
   */
  sendMessage(msg: SendMessageProps, cmd?: Command) {
    msg = this.fillMsg(msg);
    if (!cmd) cmd = Command.COMMAND_CHAT;
    const head = this.buildMessageHead(msg.to, msg.chatType);
    if (msg.messageId) head.messageId = msg.messageId;
    msg.messageHead = head;
    if (msg.timeLen) msg.fileTime = msg.timeLen;
    this.log("send message", msg, cmd);
    //delete msg["to"];
    const buffer = this.encodeMessage(msg, cmd);
    this.sendBytes(buffer);
    return msg;
  }

  /**
   * 处理聊天信息
   * @param message 见SendMessageProps
   */
  private handleCommandChat(message: SendMessageProps) {
    this.sendReceipt(message.messageId);
    switch (message.type) {
      case MessageType.MESSAGE:
        this.emit(NWEventName.COMMAND_CHAT, message);
        break;
      case MessageType.IMAGE:
        this.emit(NWEventName.IMAGE, message);
        break;
      case MessageType.FILE:
        this.emit(NWEventName.FILE, message);
        break;
      case MessageType.CONTROL:
        this.emit(NWEventName.CONTROL, message);
        break;
      case MessageType.CALL_AUDIO:
        this.emit(NWEventName.RECEIVE_AUDIO, message);
        break;
      case MessageType.RECEIPT_CALL_AUDIO:
        this.emit(NWEventName.RECEIPT_CALL_AUDIO, message);
        break;
      case MessageType.ACCEPT_CALL_AUDIO:
        this.emit(NWEventName.ACCEPT_CALL_AUDIO, message);
        break;
      case MessageType.REFUSE_CALL_AUDIO:
        this.emit(NWEventName.REFUSE_CALL_AUDIO, message);
        break;
      case MessageType.HANGUP_AUDIO:
        this.destroyMeeting();
        this.emit(NWEventName.HANGUP_AUDIO, message);
        break;
      case MessageType.CALL_VIDEO:
        this.emit(NWEventName.RECEIVE_VIDEO, message);
        break;
      case MessageType.RECEIPT_CALL_VIDEO:
        this.emit(NWEventName.RECEIPT_CALL_VIDEO, message);
        break;
      case MessageType.ACCEPT_CALL_VIDEO:
        this.emit(NWEventName.ACCEPT_CALL_VIDEO, message);
        break;
      case MessageType.REFUSE_CALL_VIDEO:
        this.emit(NWEventName.REFUSE_CALL_VIDEO, message);
        break;
      case MessageType.HANGUP_VIDEO:
        this.destroyMeeting();
        this.emit(NWEventName.HANGUP_VIDEO, message);
        break;
        case MessageType.CALL_SHARE:
          this.emit(NWEventName.RECEIVE_SHARE, message);
          break;
        case MessageType.RECEIPT_CALL_SHARE:
          this.emit(NWEventName.RECEIPT_CALL_SHARE, message);
          break;
        case MessageType.ACCEPT_CALL_SHARE:
          this.emit(NWEventName.ACCEPT_CALL_SHARE, message);
          break;
        case MessageType.REFUSE_CALL_SHARE:
          this.emit(NWEventName.REFUSE_CALL_SHARE, message);
          break;
        case MessageType.HANGUP_SHARE:
          this.destroyMeeting();
          this.emit(NWEventName.HANGUP_SHARE, message);
          break;
      default:
        this.emit("other", message);
        break;
    }
  }

  /**
   * 根据不同的消息体，调用不同的处理方式
   * @param cmd 见Command
   * @param message 从服务端接收到的消息
   */
  private handlerMessageByCommand(cmd: Command, message: any) {
    /*发送客户端消息回执*/
    if (
      ChatType.CHAT == message.chatType &&
      85 < message.type &&
      94 > message.type
    ) {
      return;
    } else if (
      ChatType.GROUPCHAT == message.chatType &&
      this.options.userIdStr == message.fromJid
    ) {
      this.emit("message", message.messageId);
    }
    switch (cmd) {
      case Command.COMMAND_CHAT:
        this.log("/*聊天请求*/", cmd, message);
        this.handleCommandChat(message);
        break;
      case Command.SUCCESS:
        this.log("/*成功请求*/", cmd, message);
        this.emit("success", message.messageId);
        break;
      case Command.MESSAGE_RECEIPT:
        this.log("/*消息回执*/", cmd, message);
        this.emit("receipt", message.messageId);
        break;
      // case Command.PULL_BATCH_GROUP_MESSAGE_RESP:
      //     break;
      // case Command.PULL_MESSAGE_RECORD_RESP:
      //     break;
      case Command.COMMAND_AUTH_RESP:
        this.log("/*登录消息结果*/", cmd, message);
        // 判断连接是否成功
        if (message.status === 1) {
          // 发送成功回执
          this.cache.resolve(message);
        } else {
          //如果失败， 关闭 websocket 连接， 并且移除， 并给出失败信息
          if (this.websocket) {
            this.websocket.close();
            this.websocket = null;
          }
          this.cache.reject(message);
        }
        break;
      case Command.Login_Conflict:
        this.log("/*登陆 被挤下线*/", cmd, message);
        this.emit("conflict");
        this.destroy();
        break;
      // case Command.CONTROL:
      //   this.log("/*控制指令*/", cmd, message);
      //   this.emit("control", cmd, message);
      //   break;
      // case Command.CALL:
      //   this.log("/*呼叫指令*/", cmd, message);
      //   debugger;
      //   this.emit("call", cmd, message);
      //   break;
      // case Command.RECEIPT_CALL:
      //   this.log("/*收到呼叫*/", cmd, message);
      //   this.emit("receiptCall", cmd, message);
      //   break;
      // case Command.ACCEPT_CALL:
      //   this.log("/*同意呼叫*/", cmd, message);
      //   this.emit("acceptCall", cmd, message);
      //   break;
      // case Command.REFUSE_CALL:
      //   this.log("/*拒绝呼叫*/", cmd, message);
      //   this.emit("refuseCall", cmd, message);
      //   break;
      default:
        //默认 其他
        break;
    }
  }

  /**
   * 当接收到消息的时候往服务器发送回执
   * @param messageId 消息唯一ID
   */
  private sendReceipt(messageId: string) {
    this.cache.waitSendReceiptIds += messageId + ",";
    if (!this.cache.sendReceiptTask) {
      this.cache.sendReceiptTask = window.setInterval(() => {
        if ("" == this.cache.waitSendReceiptIds) return;
        const receipt = this.buildReceiptMessage(
          this.cache.waitSendReceiptIds,
          1,
          ""
        );
        const buffer = this.encodeMessage(receipt, Command.MESSAGE_RECEIPT);
        this.sendBytes(buffer);
        this.log("sendReceipt ===> " + JSON.stringify(receipt));
        this.cache.waitSendReceiptIds = "";
      }, 3000);
    }
  }

  /**
   * 生成回执信息
   * @param messageId 消息唯一ID
   * @param chatType 聊天类型， 目前只支持单聊
   * @param to 接收方的Id
   */
  private buildReceiptMessage(
    messageId: string,
    chatType: ChatType,
    to: string
  ): NWMessage {
    const head = this.buildMessageHead(to, chatType);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return <NWMessage>{
      messageHead: head,
      messageId: messageId,
      status: 2,
    };
  }

  /**
   * 转换为 客户端的 消息
   * @param msg 收到的消息
   * @private
   */
  private convertToClientMsg(msg: any) {
    msg = JSON.parse(JSON.stringify(msg));
    const message = msg;
    if (msg.messageHead) {
      if (ChatType.GROUPCHAT == msg.messageHead.chatType) {
        message.from = msg.messageHead.to;
        message.to = this.options.userIdStr;
        message.fromJid = msg.messageHead.from;
      } else {
        message.from = msg.messageHead.from;
        message.to = msg.messageHead.to;
      }

      message.messageId = msg.messageHead.messageId;
      message.timeSend = parseInt(message.timeSend);
      message.chatType = msg.messageHead.chatType;
      message.offline = msg.messageHead.offline;

      if (message.fileSize) message.fileSize = parseInt(message.fileSize);

      if (message.fileTime) message.timeLen = message.fileTime;

      if (message.deleteTime) message.deleteTime = parseInt(message.deleteTime);

      if (message.locationX) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        message.location_x = message.locationX;
        delete message["locationX"];
      }
      if (message.locationY) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        message.location_y = message.locationY;
        delete message["locationY"];
      }

      delete message["messageHead"];
      delete message["fileTime"];
    } else {
      message.messageId = msg.messageId;
      message.chatType = msg.chatType;
    }

    /* var dataStr=JSON.stringify(message);
                     console.log("convertToClientMsg end  ===> "+dataStr);*/
    return message;
  }

  /**
   * 发送图片信息
   * @param payload 见SendFileOrImgPayload
   */
  async sendImageMessage(payload: SendFileOrImgPayload) {
    return this.sendFile(payload, "image");
  }
  /**
   * 发送文件信息
   * @param payload 见SendFileOrImgPayload
   */
  async sendFileMessage(payload: SendFileOrImgPayload) {
    return this.sendFile(payload, "file");
  }

  /**
   * 发送文件API
   * @param payload
   * @param type
   * @private
   */
  private async sendFile(payload: SendFileOrImgPayload, type = "file") {
    const info = await this.selectFileAndUpload(type);
    return this.sendMessage({
      chatType: 2,
      content: "",
      fileName: "",
      fromUserId: this.options.userId,
      from: this.options.userIdStr,
      isReadDel: false,
      ...payload,
      ...info,
    });
  }

  /**
   * 选择文件并上传文件到服务器
   * @param type
   */
  private selectFileAndUpload(type: string): any {
    const target = document.createElement("input");
    target.type = "file";
    target.click();
    return new Promise((resolve, reject) => {
      target.addEventListener("change", async (e) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        const sendFile = e.target.files[0];
        if (sendFile) {
          // 判断当前是否有文件上传的钩子
          // @ts-ignore
          if (this.options.hooks.beforeSendFile) {
            // @ts-ignore
            if (!this.options.hooks.beforeSendFile(sendFile, type)) {
              return false;
            }
          }
          const uploadData = await this.uploadFile(sendFile, type);
          const { file, data } = uploadData;
          this.emit("uploadSuccess", uploadData);
          const { name, size } = file;
          resolve({
            fileName: name,
            content: data.url,
            fromUserName: this.options.userId,
            type: type === "image" ? 2 : 9,
            timeSend: Math.round(Date.now() / 1000),
            fileSize: size,
          });
        } else {
          reject(new Error("未选择文件"));
        }
      });
    });
  }

  /**
   * 上传文件
   * @param file 文件对象
   * @param type 是图片还是文件
   */
  private uploadFile(file: any, type: string): Promise<UploadResponse> {
    const url =
      type === "image"
        ? `${this.options.uploadServer}/upload/UploadifyImageServlet`
        : `${this.options.uploadServer}/upload/UploadifyServlet`;
    const form = new FormData();
    if (type === "image") {
      form.append("image", file);
    } else if (type === "file") {
      form.append("files", file);
    }
    form.append("userId", this.options.userId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const result = JSON.parse(xhr.response);
          if (result.resultCode !== -1) {
            resolve({
              file: file,
              response: xhr,
              data: result,
            });
          } else {
            reject(result);
          }
        }
      };
      xhr.onerror = reject;
      xhr.upload.addEventListener(
        "progress",
        (event) => {
          this.emit("upload", "image", event);
        },
        false
      );
      xhr.open("POST", url);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.send(form);
    });
  }

  /**
   * 解码
   * @param buffer
   * @param cmd
   * @param messageType
   * @private
   */
  private decodeMessage(
    buffer: ArrayBuffer,
    cmd: Command,
    messageType?: ProtoMessageEnum
  ) {
    if (cmd) {
      if (!messageType) messageType = this.getProtoMessageType(cmd);
      return messageType.decode(buffer);
    } else {
      return messageType.decode(buffer);
    }
  }

  /**
   * 生成认证信息
   */
  private buildAuthMessage() {
    const head = this.buildMessageHead("server", ChatType.AUTH);
    const message: NWMessage = {
      messageHead: head,
      token: this.options.token,
      deviceId: this.options.deviceId,
    };
    return message;
  }

  /**
   * 创建消息头
   * @param to
   * @param chatType
   * @private
   */
  private buildMessageHead(to: string, chatType: ChatType) {
    return {
      from: this.options.userIdStr,
      messageId: this.randomUUID(),
      chatType: !chatType ? 0 : chatType,
      to: !to ? "" : to + "",
    };
  }

  /**
   * 生成随机ID
   */
  private randomUUID() {
    const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
        ""
      ),
      uuid = new Array(36);
    let r,
      rnd = 0;
    for (let i = 0; i < 36; i++) {
      if (i == 8 || i == 13 || i == 18 || i == 23) {
        uuid[i] = "-";
      } else if (i == 14) {
        uuid[i] = "4";
      } else {
        if (rnd <= 0x02) rnd = (0x2000000 + Math.random() * 0x1000000) | 0;
        r = rnd & 0xf;
        rnd = rnd >> 4;
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
    return uuid
      .join("")
      .replace(/-/gm, "")
      .toLowerCase();
  }

  /**
   * 发送Bytes 这个发送最终消息体
   * @param bytes
   */
  private sendBytes(bytes: any) {
    if (!this.isConnect()) {
      throw new IMError(400);
    }
    // this.log("sendBytes  ===>  " + bytes);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (bytes.length > this.options.maxLength) {
      this.log("报文长度为", this.options.maxLength);
      throw new Error(`最大消息长度不能超过${this.options.maxLength}`);
    }
    // @ts-ignore
    this.websocket.send(bytes);
  }

  /**
   * 判断当前IM 服务器是否连接
   */
  isConnect(): boolean {
    if (!this.websocket) return false;
    return 1 == this.websocket.readyState;
  }

  /**
   * 编码
   * @param message
   * @param cmd
   * @param messageType
   * @private
   */
  private encodeMessage(
    message: NWMessage | SendMessageProps,
    cmd: Command,
    messageType?: ProtoMessageEnum
  ) {
    if (!messageType) messageType = this.getProtoMessageType(cmd);

    const errMsg = messageType.verify(message);
    if (errMsg) {
      throw Error(errMsg);
    }
    const wsMessage = messageType.create(message);

    const buffer = messageType.encode(wsMessage).finish();
    if (cmd) {
      const bytes = new Uint8Array(buffer.length + 1);
      bytes[0] = cmd;
      for (let i = 0; i < buffer.length; i++) {
        bytes[i + 1] = buffer[i];
      }
      return bytes;
    } else {
      return buffer;
    }
  }

  /**
   * 根据 cmd 获取 proto 的编解码 MessageType
   * @param cmd
   * @private
   */
  private getProtoMessageType(cmd: Command): ProtoMessageEnum | null {
    switch (cmd) {
      case Command.COMMAND_CHAT:
        return ProtoMessageType.chatMessage;
      case Command.COMMAND_AUTH_REQ:
        return ProtoMessageType.authMessageReq;
      case Command.COMMAND_AUTH_RESP:
        return ProtoMessageType.authMessageResp;
      case Command.MESSAGE_RECEIPT:
        return ProtoMessageType.messageReceipt;
      case Command.PULL_MESSAGE_RECORD_REQ:
        return ProtoMessageType.pullMessageHistoryRecordReq;
      case Command.PULL_MESSAGE_RECORD_RESP:
        return ProtoMessageType.pullMessageHistoryRecordResp;
      case Command.PULL_BATCH_GROUP_MESSAGE_REQ:
        return ProtoMessageType.pullBatchGroupMessageReq;
      case Command.PULL_BATCH_GROUP_MESSAGE_RESP:
        return ProtoMessageType.pullBatchGroupMessageResp;
      case Command.SUCCESS:
        return ProtoMessageType.commonSuccess;
      case Command.ERROR:
        return ProtoMessageType.commonError;
      case Command.Ping_REQ:
        return ProtoMessageType.pingMessage;
      case Command.JOINGROUP_REQ:
        return ProtoMessageType.joinGroupMessage;
      case Command.EXITGROUP_REQ:
        return ProtoMessageType.exitGroupMessage;
      case Command.GROUP_REQUEST_RESULT:
        return ProtoMessageType.groupMessageResp;
      case Command.Login_Conflict:
        return ProtoMessageType.commonError;
      default:
        //默认 其他
        return null;
    }
  }

  /**
   * 加入会议之前预处理 申请开始会议， 并且加入会议
   * @param userId 当前用户ID
   * @param meetingId 会议ID
   * @private
   */
  private async preJoin(userId: string, meetingId: string) {
    this.cache.isAdd = false;
    const res1 = await this.ajax(
      "put",
      `/api/iflyco/v1/conference/start/${meetingId}?token=${this.options.token}`,
      ""
    );
    const res2 = await this.ajax(
      "POST",
      `/api/iflyco/v1/conference/join?token=${this.options.token}`,
      JSON.stringify({
        userId: userId,
        conferenceNum: meetingId,
      })
    );
    if (res2.data.code !== 200) {
      throw new Error("加入会议失败");
    }
    setTimeout(() => {
      this.log("当前添加状态", this.cache.isAdd);
      if (this.cache.isAdd === false) {
        this.destroyMeeting();
        this.emit("notJoin");
        throw new Error("对方没有加入");
      }
    }, 15e3);
  }

  /**
   * 初始化飞讯会议DOM组件
   * @param token 会议ID
   * @param userId 用户ID
   * @param useCamera 是否使用摄像头
   * @private
   */
  private mediaCall(token: string, userId: string, useCamera: boolean = false) {
    const options: any = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      destination_number: token,
      // eslint-disable-next-line @typescript-eslint/camelcase
      caller_id_name: userId,
      // eslint-disable-next-line @typescript-eslint/camelcase
      caller_id_number: userId,
      useMic: "any",
      useSpeak: "any",
      userVariables: {
        userName: userId && userId.length > 20 ? userId.substr(0, 20) : userId,
        userType: "1",
        userId: userId,
      },
    };
    if (useCamera) {
      options.useCamera = "any";
    }
    return this.coolVideoDom.newCall(options);
  }

  /**
   * 飞讯会议DOM组件 - 屏幕分享
   * @param token 会议ID
   * @param isHost 是否是主持人
   * @private
   */
  private doShareCall(token: string, isHost: boolean) {
    // if (this.coolVideo) {
    //   this.coolVideo.hangup()
    //   return
    // }
    let destinationNumber = token + '#';
    if(isHost){
        destinationNumber += '1'; // 如果是主持人，加上：1
    }
    destinationNumber += '-screen'; // 如果是屏幕分享，加上：-screen
    const { userId } = this.options;
    const options: any = {
      destination_number: destinationNumber,
        caller_id_name: `${userId}(Screen)`,
        caller_id_number: `${userId}(screen)`,
          videoParams: {  //分辨率。经我们开发时的对比实践后，建议设为 1080 的分辨率，可保障清晰度
            maxHeight: 1080,
            maxWidth: 1920,
            minFrameRate: 15,
            minHeight: 1080,
            minWidth: 1920,
          },
        screenShare: true  //必传，屏幕分享标识
    }
    this.shareCall = this.coolVideoDom.newCall(options)
  }
  /**
   * 关闭屏幕分享(后续的逻辑暂未处理，已可直接挂断 不调用此接口)
   */
  private closeShare() {
    this.shareCall.hangup()
  }
  /**
   * 回调钩子
   */
  callbacks: any = {
    /**
     * onResponse  信令服务器返回消息时调用
     * 服务端返回'verto.event'类型的消息时调用
     * @param {object} verto 信令handle
     * @param {object} data 服务端返回的消息内容，数据结构请参考 /docs/modCommand.js
     */
    onResponse: (verto: any, data: any) => {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      that.cache.isAdd = false;
      const myConfMan = new FX.CoolVideo.confMan(verto, {
        laData: data.pvtData,
        participantsCallback: (res: any) => {
          // res 的数据结构请参考 /docs/modCommand.js 的
          //  modifyFromServer.params.data 层
          if (!res) return;
          if (res.action === "bootObj") {
            // 会议链接成功后返回的数据。返回内容包括当前音视频会议内的所有用户数据，包括声音/视频状态、userId等
            if (res.data.length > 1) {
              that.cache.isAdd = true;
            }
          }
          //
          if (res.action === "add") {
            that.cache.isAdd = true;
          }

          if (res.action === "del") {
            // 屏幕分享专用用户退出 不作为参会人退出 (屏幕分享用户包含screen)
            if (res.data[1].includes('screen')) return
            this.emit("exit");
            // 1、参会人退出会议时调用
            // 2、当前用户被踢出会议时调用
          }
          // if (res.action === "modify") {
          //   // 开/静音、参会人说话、开关视频时调用
          // }
        },
      });
    },
    onError: (err: any) => {
      this.emit("error", err);
    },
    // 接收到远程视频流时的回调
    onRemoteStream: () => {
      // 目的：入会静音。
      // this.coolVideo.dtmf("0");
      // 目的：入会关闭视频
      console.log('--onRemoteStream-----')
      this.coolVideo.dtmf("*0");
      // this.coolVideo.setVideoMute('off')
    },
    // 有成员共享屏幕时的回调
    onMemberScreenShareChanded: (memberData: any, open: boolean) => {
      console.log('有成员共享屏幕', memberData, open);
      // 目的：入会关闭视频
      this.coolVideo.dtmf("*0");
    },
    // 有成员视频状态改变的回调
    onMemberVideoChanged: (memberData: any, open: boolean) => {},
    // 有成员音频状态改变的回调
    onMemberAudioChanged: (memberData: any, open: boolean) => {},
  };
  /**
   * 初始化DOM控件
   * @param dom videoDOM
   * @param meetingId 会议ID
   */
  async initVideoTag(dom: HTMLVideoElement, meetingId: string) {
    const { userId, videoWS } = this.options;
    this.cache.meetingId = meetingId;
    const res = await this.preJoin(userId, meetingId);
    const callbacks = { ...this.callbacks };
    delete callbacks.onRemoteStream;
    this.coolVideoDom = new FX.CoolVideo(
      {
        socketUrl: videoWS,
        tag: dom,
        sessid: userId,
        videoParams: {
          width: { min: 640, ideal: 1280, max: 1280 },
          height: { min: 480, ideal: 720, max: 720 },
          frameRate: { min: 20, ideal: 20, max: 30 },
          vertoBestFrameRate: 20,
        },
        deviceParams: { useCamera: "any", useMic: "any", useSpeak: "any" },
      },
      callbacks
    );
    this.coolVideo = this.mediaCall(meetingId, userId, true);
    // this.coolVideo.dtmf("*0");
    return this.coolVideo;
  }
  async initShareTag(dom: HTMLVideoElement, meetingId: string, isCaller: boolean) {
    const { userId, videoWS } = this.options;
    this.cache.meetingId = meetingId;
    const res = await this.preJoin(userId, meetingId);
    const callbacks = { ...this.callbacks };
    this.coolVideoDom = new FX.CoolVideo(
      {
        socketUrl: videoWS,
        tag: dom,
        sessid: userId,
        videoParams: {
          width: { min: 640, ideal: 1280, max: 1280 },
          height: { min: 480, ideal: 720, max: 720 },
          frameRate: { min: 20, ideal: 20, max: 30 },
          vertoBestFrameRate: 20,
        },
        deviceParams: { useCamera: "any", useMic: "any", useSpeak: "any" },
      },
      callbacks
    );
    if (isCaller) {
      this.coolVideo = this.mediaCall(meetingId, userId, false);
      setTimeout(() => {
        this.doShareCall(meetingId, true)
      }, 500)
    } else {
      this.coolVideo = this.mediaCall(meetingId, userId);
    }

    // // 临时之策，关闭摄像头
    // setTimeout(() => {
    //   this.coolVideo.dtmf("*0");
    //   setTimeout(() => {
    //     this.coolVideo.dtmf("*0");
    //   }, 1000)
    // }, 5000)
    
    // this.coolVideo.dtmf("*0");
    return this.coolVideo;
  }
  /**
   * 初始化DOM控件
   * @param dom videoDOM标签
   */
  async initAudioTag(dom: HTMLVideoElement, meetingId: string) {
    const { userId, videoWS } = this.options;
    this.cache.meetingId = meetingId;
    await this.preJoin(userId, meetingId);
    this.coolVideoDom = new FX.CoolVideo(
      {
        socketUrl: videoWS,
        tag: dom,
        sessid: userId,
        deviceParams: { useMic: "any", useSpeak: "any" },
      },
      { ...this.callbacks }
    );
    this.coolVideo = this.mediaCall(meetingId, userId);
    return this.coolVideo;
  }
}

export default IMCore;
